/**
 * サイドバーの開閉ボタンを追加
 */
// @ts-ignore
const mtappVars = window.mtappVars;
export function sidebarCollapse() {
    const body = document.body;
    if (body.classList.contains('preview-screen')) {
        return;
    }

    if (window.top !== window) {
        return;
    }

    const btn = document.createElement('button');
    btn.id = 'mtapp-sidebar-collapse';
    btn.type = 'button';
    btn.innerHTML = `
        <svg title="Full Screen" role="img" class="mt-icon">
            <use xlink:href="${mtappVars.static_path}images/sprite.svg#ic_fullscreen" />
        </svg>`;

    const selector = ['.mt-secondaryPanel', '.mt-secondaryPanel--scrollable']
    if (!['admin2025'].includes(mtappVars.admin_theme_id)) {
        selector.push('.mt-primaryNavigation');
    }

    btn.addEventListener('click', function () {
        const elementsToToggle = document.querySelectorAll(selector.join(','));
        elementsToToggle.forEach((element) => {
            element.classList.toggle('d-none');
        });
    });

    body.appendChild(btn);
}
